<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { dynamicTime } from 'shared/helpers/timeHelper';

const props = defineProps({
  notification: { type: Object, required: true },
});
const emit = defineEmits(['open']);
const { t } = useI18n();

const message = computed(() => {
  if (
    props.notification.message_key === 'POST_SALE.NOTIFICATIONS.STATUS_CHANGED'
  ) {
    return t('POST_SALE.NOTIFICATIONS.STATUS_CHANGED');
  }
  if (
    props.notification.message_key ===
      'POST_SALE.NOTIFICATIONS.DEED_FEEDBACK_SUBMITTED' ||
    props.notification.notification_type === 'deed_feedback_submitted'
  ) {
    return t('POST_SALE.NOTIFICATIONS.DEED_FEEDBACK_SUBMITTED');
  }

  return t('POST_SALE.NOTIFICATIONS.GENERIC');
});
</script>

<template>
  <button
    type="button"
    class="flex w-full gap-3 border-b border-lais-border-soft px-4 py-3 text-left hover:bg-lais-bg-soft"
    :class="{ 'bg-lais-primary-50/40': !notification.read }"
    :data-testid="`post-sale-notification-${notification.id}`"
    @click="emit('open', notification)"
  >
    <span
      class="mt-1 size-2 shrink-0 rounded-full"
      :class="notification.read ? 'bg-transparent' : 'bg-lais-primary'"
    />
    <span class="min-w-0 flex-1">
      <span class="block truncate text-sm font-semibold text-lais-text">
        {{ notification.address || t('POST_SALE.COMMON.ADDRESS_UNAVAILABLE') }}
      </span>
      <span class="mt-1 block text-xs text-lais-text-body">{{ message }}</span>
      <span class="mt-1 block text-[11px] text-lais-text-muted">
        {{ dynamicTime(notification.created_at) }}
      </span>
    </span>
  </button>
</template>
